import * as React from "react";
import styles from "./CheckBox.module.scss";
import CheckboxIcon from "../../icons/CheckboxIcon";
import classnames from "classnames";

export function Checkbox(props) {
    const { onChange, checked, disabled, error, dataTestId, style } = props;

    return (
        <div className={styles["checkbox-wrapper"]} style={style}>
            <input
                data-test-id={dataTestId}
                onChange={onChange || (() => {})}
                disabled={disabled}
                checked={checked}
                className={classnames(styles["checkbox"], disabled && styles["disabled"], error && styles["error"])}
                type="checkbox"
            />
            {checked && (
                <div className={styles["checkbox-icon"]}>
                    <CheckboxIcon background={false} />
                </div>
            )}
        </div>
    );
}
